import type {
  Control,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/EndPoint";
import DateRangePicker from "../Reusable/DateRangePicker";
import { type IFilterReturn } from "../../types/interface";
import { classNames } from "../../utils/classNames";
import ComboboxFilter from "../Reusable/ComboboxFilter";

interface Props {
  setValue: UseFormSetValue<IFilterReturn>;
  getValues: UseFormGetValues<IFilterReturn>;
  isFilterVisible: boolean;
  control: Control<IFilterReturn, any>;
  handleFilterReset: () => void;
}

const ReturnOrderFilter = ({
  control,
  setValue,
  getValues,
  isFilterVisible,
  handleFilterReset,
}: Props) => {
  return (
    <div
      className={classNames(
        isFilterVisible ? tw`block` : tw`hidden`,
        tw`relative`
      )}
    >
      {isFilterVisible ? (
        <div className={tw`grid grid-cols-3 md:grid-cols-3 gap-x-4 mx-4`}>
          <DateRangePicker
            label={"Select Date Range"}
            setValue={setValue}
            name={"created__range"}
            getValues={getValues}
          />
          <ComboboxFilter<IFilterReturn>
            url={APIS.MERCHANT}
            queryKey={"merchant"}
            name={"merchant"}
            label={"Vendor"}
            params={{
              is_active: true,
            }}
            placeholder={"Select Vendor"}
            control={control}
          />
          <ComboboxFilter<IFilterReturn>
            url={APIS.DRIVER}
            queryKey={"driver"}
            name={"driver"}
            label={"Driver"}
            params={{
              is_active: true,
            }}
            placeholder={"Search driver"}
            control={control}
          />
        </div>
      ) : (
        ""
      )}
      <button
        className={tw`absolute -top-5 right-5`}
        onClick={handleFilterReset}
      >
        Reset
      </button>
    </div>
  );
};

export default ReturnOrderFilter;
